import React from "react"
import styled from "styled-components"
import tw from "twin.macro"

const Filter = tw.div`
  mb-4 w-full relative
`

const Label = tw.label`
  block mb-2
  text-blue-prussian
  text-26
`

const TagList = styled.div<{ isSmall?: boolean }>`
  ${tw`flex`}
  ${({ isSmall }) => (isSmall ? tw`flex-wrap` : tw`flex-col`)}
`

const TagInput = tw.input`
  hidden
`

const TagLabel = styled.label<{ isSmall?: boolean }>`
  ${tw`p-2 rounded-xl border border-blue-cerulean
    m-1
    bg-transparent text-blue-prussian text-center
    aria-checked:(bg-blue-cerulean text-blue-sky border-blue-cerulean)`}
  ${({ isSmall }) => isSmall && tw`px-4 w-fit`}
`

interface FilterItemProps {
  label: string;
  options: string[] | (number | string)[];
  selectedValues: string[] | string;
  onChange: (value: string | string[]) => void;
  isMultiSelect?: boolean;
  isSmall?: boolean;
}

const ButtonFilterSection: React.FC<FilterItemProps> = ({
  label,
  options,
  selectedValues,
  onChange,
  isMultiSelect = false,
  isSmall = false,
}) => {
  const handleChange = (value: string) => {
    if (isMultiSelect && Array.isArray(selectedValues)) {
      const updatedValues = selectedValues.includes(value)
        ? selectedValues.filter((selectedValue) => selectedValue !== value)
        : [...selectedValues, value]
      onChange(updatedValues)
    } else {
      onChange(selectedValues === value ? "" : value)
    }
  }

  return (
    <Filter>
      <Label>{label}</Label>
      <TagList isSmall={isSmall}>
        {options.map((option) => {
          const optionValue = String(option)
          const isChecked = isMultiSelect && Array.isArray(selectedValues)
            ? selectedValues.includes(optionValue)
            : selectedValues === optionValue

          return (
            <React.Fragment key={optionValue}>
              <TagInput
                type="checkbox"
                id={optionValue}
                name={label}
                value={optionValue}
                checked={isChecked}
                onChange={() => handleChange(optionValue)}
              />
              <TagLabel
                htmlFor={optionValue}
                isSmall={isSmall}
                aria-checked={isChecked}
              >
                {option}
              </TagLabel>
            </React.Fragment>
          )
        })}
      </TagList>
    </Filter>
  )
}

export default ButtonFilterSection
